const state = {
  query: {}
}

const actions = {
  setQuery({ commit, state }, payload) {
    commit('setQuery', {
      ...state.query,
      [payload.key]: payload.query
    })

    return true
  }
}

const mutations = {
  setQuery(state, payload) {
    state.query = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
